//import dependencies and resources
import { useState,useRef } from 'react'
import '../styles/output.css'
import '../styles/global.css'
//export Gallery component (contains the images, both thumbnails and display)
let Gallery=()=>{
    //array of image data (paths)
    const artData=[ 
        {id:0, imgsrc:'/images/works/sunset music 1.3.jpg'},
        {id:1, imgsrc:'/images/works/Homicide1.3.jpg'},
        {id:2, imgsrc:'/images/works/Crymusicconcept3.jpg'},
        {id:3, imgsrc:'/images/works/tune burnout1.jpg'},
        {id:4, imgsrc:'/images/works/wof.jpg'},
        {id:5, imgsrc:'/images/works/bottle2.0.jpg'},
        {id:6, imgsrc:'/images/works/bst 1.5.jpg'},
        {id:7, imgsrc:'/images/works/dcxvi style 1.1red.jpg'},
        {id:8, imgsrc:'/images/works/wood.jpg'},
    ]
    const posters=[
        {id:0, imgsrc:'/images/posters/heavy_trap_v0.1.png'},
        {id:1, imgsrc:'/images/posters/opiamuuu.png'},
        {id:2, imgsrc:'/images/posters/RAGE.png'},
        {id:3, imgsrc:'/images/posters/slime_normal.png'},
        {id:4, imgsrc:'/images/posters/SnapInsta.to_503849823_18508441516028741_2938640980781036944_n.jpg'},
        {id:5, imgsrc:'/images/posters/SnapInsta.to_504012709_18508441504028741_7974765844974390739_n.jpg'},
        {id:6, imgsrc:'/images/posters/trap_baddiesFINAL.jpg'},
    ]
    //states for tracking the path of the clicked image & toggling the Image viewer on and off
    let [imagegroup, setImageGroup] =useState(artData)
    const [clickedSrc,setClickedSrc] = useState('')
    let [current,setCurrent] = useState(0)
    const [Displayed,setDisplayed] = useState(false)
    let cover_art =useRef(null)
    let poster_art=useRef(null)
    let cover_link =useRef(null)
    let poster_link=useRef(null)
    let Show=(cover)=>{
          setCurrent(cover.id)
          setClickedSrc(cover.imgsrc)
          setDisplayed(true)
        }
    let previous=()=>{
        if(current>0){
            setCurrent(current-=1);
            setClickedSrc(imagegroup[current].imgsrc)
        }
        else{
            console.log('Beginning')
        }
    }
    let next =()=>{
        if(current<(imagegroup.length-1)){
            setCurrent(current+=1)
            setClickedSrc(imagegroup[current].imgsrc)
        }
        else{
            console.log('End')
        }
    }
    let showCovers=()=>{
        setImageGroup(artData)
        cover_art.current?.scrollIntoView({ behavior: 'smooth',block:'nearest', inline: 'start',});
        cover_link.current?.classList.replace('text-white','text-yellow-400')
        poster_link.current?.classList.replace('text-yellow-400','text-white')
    }
    let showPosters=()=>{
        setImageGroup(posters)
        poster_art.current?.scrollIntoView({ behavior: 'smooth',block:'nearest', inline: 'start' });
        poster_link.current?.classList.replace('text-white','text-yellow-400')
        cover_link.current?.classList.replace('text-yellow-400','text-white')
    }
    return(
        <>
        <div className={Displayed ? 'Gallery Up': 'Gallery'}>
            <button className='text-white m-2 Close' onClick={()=>{setDisplayed(false)}}>Close</button>
            <button className='text-white mx-2' onClick={previous}> Previous </button>
            <img src={clickedSrc} alt='' className='DisplayedImg mobile-l:scale-90 mobile-m:scale-80 mobile-s:scale-75' onContextMenu={(e)=>{e.preventDefault()}}/>
            <button className='text-white mx-2' onClick={next}> Next </button>
        </div>
        
            
        <div className='w-full flex flex-col flex-shrink-0 items-center'>
            {/* Work navigation section below */}
            <div>
            <ul className='flex flex-row justify-center items-center px-1 mb-4'>
                   <li ref={cover_link} onClick={showCovers} className='font-semibold mx-3 text-yellow-400 cursor-pointer'>Covers</li>
                   <li ref={poster_link} onClick={showPosters} className='font-semibold mx-3 text-white cursor-pointer'>Posters</li>
                </ul>
            </div>
            {/* Works below */}
        <div className='w-80 h-80 flex flex-row flex-nowrap overflow-x-auto overflow-y-hidden hide-scrollbar'>
            <div className='w-80 shrink-0 flex flex-row flex-wrap' ref={cover_art}>
                {artData.map((item)=>{
                return(
                    <div key={item.id}>
                     <img src={item.imgsrc} alt='' loading='lazy' className='size-24 m-1 thumbnail'  onClick={()=>{Show(item)}} onContextMenu={(e)=>{e.preventDefault()}}/>
                    </div>
                )
            })}
            </div>
            <div className='w-80 shrink-0 flex flex-row flex-wrap' ref={poster_art}>
                {posters.map((poster)=>{
                return(
                    <div key={poster.id}>
                     <img src={poster.imgsrc} alt='' loading='lazy' className='size-24 m-1 thumbnail' onClick={()=>{Show(poster)}} onContextMenu={(e)=>{e.preventDefault()}}/>
                    </div>
                )
            })}
            </div>
             
        </div>
        </div>
        </>
    )
}
export default Gallery